export const isArray = <T>(items: T[] | T): items is T[] => Array.isArray(items);
export const isArrayOf = <T>(items: T[] | T): items is T[] => Array.isArray(items);

type NestedArray<T> = T | NestedArray<T>[];
export const isNonNestedArray = <T>(items: T[] | NestedArray<T>): items is T[] =>
  Array.isArray(items) && !Array.isArray(items[0]);

export const removeDuplicates = <T>(array: T[]) => [...new Set(array)];
